import { Injectable, signal, inject, effect } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { Navigation } from '../models';
import { hasValue } from '@my-aon/utils';


@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    private navigation!: Navigation[];
    readonly $navigation = signal<Navigation[]>(this.navigation);
    readonly navigation$ = toObservable(this.$navigation);

    readonly router: Router = inject(Router);
    selectedRoute: string = '';
    readonly $selectedRouteParts = signal<string[]>([]);
    selectedRouteParts!: string[];

    constructor() {

        this.router.events
            .pipe(takeUntilDestroyed())
            .subscribe(val => {
                if (val instanceof NavigationEnd) {
                    this.selectedRoute = val.urlAfterRedirects.split('?')[0];
                    this.$selectedRouteParts.set(this.selectedRoute.split('/').filter(x => !!x));
                }
            });

        effect(() => {
            this.navigation = this.$navigation();
        });

        effect(() => {
            this.selectedRouteParts = this.$selectedRouteParts();
        })

    }

    set(navigation: Navigation[]): void { this.$navigation.set(navigation); }

    get(): Navigation[] { return this.$navigation() };

    clear(): void { this.set([]); }

    getChildNavigation(rootPaths?: string[], level: number = 0): Navigation[] | undefined {

        rootPaths = rootPaths?.filter(x => hasValue(x));

        if (!rootPaths || !hasValue(rootPaths)) return this.navigation;

        const pathMatch = (a?: string, b?: string): boolean => {

            a = a?.split('/')?.filter(x => hasValue(x))?.join('/');
            b = b?.split('/')?.filter(x => hasValue(x))?.join('/');

            return a === b;
        }

        const find = (items?: Navigation[], _level: number = 0): Navigation[] | undefined => {
            if (!items || !hasValue(items)) return [];
            if (_level === level) return items;



            let child =  items.find(x => pathMatch(x.path, rootPaths[_level]));
            return child && child?.items && find(child.items as any[], ++_level);
        }

        return find(this.navigation)
    }

}
